import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RubblSharedModule } from "../rubbl-shared/rubbl-shared.module";
import { FormsModule as RubblFormsModule } from "../forms/forms.module";
import { InventoryModule } from "../inventory/inventory.module";
import { CartDiscountPhoneModalComponent } from "./components/cart-discount-phone-modal/cart-discount-phone-modal.component";
import { CartItemRemoveConfirmationComponent } from "./components/cart-item-remove-confirmation/cart-item-remove-confirmation.component";
import { CartShareModalComponent } from "./components/cart-share-modal/cart-share-modal.component";
import { MachineCardAddToCartComponent } from "./components/machine-card-add-to-cart/machine-card-add-to-cart.component";
import { AddToCartAttachmentsComponent } from "./components/machine-card-add-to-cart/add-to-cart-attachments/add-to-cart-attachments.component";
import { AddToCartDatesComponent } from "./components/machine-card-add-to-cart/add-to-cart-dates/add-to-cart-dates.component";
import { AddToCartDetailsComponent } from "./components/machine-card-add-to-cart/add-to-cart-details/add-to-cart-details.component";
import { SelfHaulInfoModalComponent } from "./components/self-haul-info-modal/self-haul-info-modal.component";
import { FormsModule } from "@angular/forms";
import { MachineCardAdvancedComponent } from "./components/machine-card-advanced/machine-card-advanced.component";
import { BuyOnlyMachineCardAdvancedComponent } from "./components/buy-only-machine-card-advanced/buy-only-machine-card-advanced.component";
import { RouterModule } from "@angular/router";
import { CoreModule } from "../core/core.module";
import { AccountModule } from "../account/account.module";
import { AzureMapsModule } from "../azure-maps/azure-maps.module";

@NgModule({
  declarations: [
    CartDiscountPhoneModalComponent,
    CartItemRemoveConfirmationComponent,
    CartShareModalComponent,
    MachineCardAddToCartComponent,
    AddToCartAttachmentsComponent,
    AddToCartDatesComponent,
    AddToCartDetailsComponent,
    SelfHaulInfoModalComponent,
    MachineCardAdvancedComponent,
    BuyOnlyMachineCardAdvancedComponent,
  ],
  imports: [CommonModule, RouterModule, RubblSharedModule, RubblFormsModule, InventoryModule, FormsModule, CoreModule, AccountModule, AzureMapsModule],
  exports: [
    CartDiscountPhoneModalComponent,
    CartItemRemoveConfirmationComponent,
    CartShareModalComponent,
    MachineCardAddToCartComponent,
    AddToCartDetailsComponent,
    MachineCardAdvancedComponent,
    BuyOnlyMachineCardAdvancedComponent,
    AddToCartDatesComponent,
  ],
})
export class CartModule {}